import React, { useEffect, useContext, useState } from "react";
import {
  Box,
  Button,
  Select,
  FormControl,
  Grid,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Typography,
  Tooltip,
  Chip,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import {
  FEEDBACK_TYPE_BUGS,
  IProductParams,
  FEEDBACK_TYPE_FEATURE_REQ,
  TRACKING_SYSTEM_SELF,
  TRACKING_SYSTEM_JIRA,
  TRACKING_SYSTEM_ZENDESK,
  FEEDBACK_TYPE_FEEDBACK,
  INVOKE_TYPE_MANUAL,
  RATING_ICON_TYPE_STAR,
  PLATFORM_TYPE_BROWSER,
  POS_RIGHT_MIDDLE,
  FEEDBACK_FLOW_STATIC,
  IFeedbackAgentSettings,
  IProductInfo,
  STATUS_PRODUCT_ACTIVE,
  webTechs,
  TYPE_NONE,
  brandingIF,
  ITrackingSystem,
} from "../../model";
import { enableChatbot, enableJira, enableZendesk } from "../../utils/config";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import HelpIcon from "@mui/icons-material/Help";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { cloneDeep } from "lodash";

import ZendeskSettingsHeader from "./ZendeskSetttingsHeader";
import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../utils/config";
import { HideOrShowText } from "../common/hideOrShowText";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const TrackingSystemSettings = (props: any) => {
  const { productId, versionId } = useParams();
  const location: any = useLocation();
  const navigate = useNavigate();

  appLogger.info({
    infoObj: {
      method: "trackingSysSettings",
      component: "add-product",
      fileName: "trackingSysSettings.tsx",
      props: props,
    },
  });
  const {
    setScroll,
    errMsg,
    setErrMsg,
    sethandleClick,
    productParams,
    setProductParams,
  } = props;

  // const [productParams, setProductParams] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState("");
  const [zendeskTagList, setZendeskTagList] = useState<any>({});
  const zendeskTicketTypeList = ["incident", "problem", "question", "task"];
  const zendeskPriorityList = ["low", "normal", "high", "urgent"];
  const [isBugToolConnected, setIsBugToolConnected] = useState(false);
  const [isFeedbackToolConnected, setIsFeedbackToolConnected] = useState(false);
  const [isFeatureToolConnected, setIsFeatureToolConnected] = useState(false);
  const { userInfo, enabledFeatures, orgId } = useContext(
    UserContext
  ) as UserLoginInfo;
  const [fieldErrMsg, setFieldErrMsg] = useState<any>({});
  const [dynamicTag, setDynamicTag] = useState("");

  const defaultZendeskSettings: ITrackingSystem = {
    feedbackTypes: [
      FEEDBACK_TYPE_FEEDBACK,
      FEEDBACK_TYPE_BUGS,
      FEEDBACK_TYPE_FEATURE_REQ,
    ],
    configs: {
      [FEEDBACK_TYPE_BUGS]: {
        auth: {},
        type: "ZENDESK",
        subject: "CuVo Chatbot ticket",
      },
      [FEEDBACK_TYPE_FEATURE_REQ]: {
        auth: {},
        type: "ZENDESK",
        subject: "CuVo Chatbot ticket",
      },
      [FEEDBACK_TYPE_FEEDBACK]: {
        auth: {},
        type: "ZENDESK",
        subject: "CuVo Chatbot ticket",
      },
    },
  };

  useEffect(() => {
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings
    ) {
      if (
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.feedbackTypes &&
        productParams.products[0].zendeskSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        )
      ) {
        if (
          productParams.products[0].zendeskSettings.configs[FEEDBACK_TYPE_BUGS]
            .type == "SELF"
        ) {
          const temp = { ...productParams };
          temp.products[0].zendeskSettings.configs[FEEDBACK_TYPE_BUGS].type =
            "ZENDESK";
          setProductParams(temp);
        }
        if (
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_BUGS
          ] &&
          productParams.products[0].zendeskSettings.configs[FEEDBACK_TYPE_BUGS]
            .isToolConnected
        ) {
          setIsBugToolConnected(true);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsBugToolConnected: true,
              },
            },
            "Tool Connected"
          );
        } else if (
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs[FEEDBACK_TYPE_BUGS]
        ) {
          setIsBugToolConnected(false);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsBugToolConnected: false,
              },
            },
            "Tool not Connected"
          );
        }
      }
      if (
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.feedbackTypes &&
        productParams.products[0].zendeskSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEATURE_REQ
        )
      ) {
        if (
          productParams.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ].type == "SELF"
        ) {
          const temp = { ...productParams };
          temp.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ].type = "ZENDESK";
          setProductParams(temp);
        }
        if (
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ] &&
          productParams.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ].isToolConnected
        ) {
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeatureToolConnected: true,
              },
            },
            "Tool Connected"
          );
          setIsFeatureToolConnected(true);
        } else if (
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ]
        ) {
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeatureToolConnected: false,
              },
            },
            "Tool not Connected"
          );
          setIsFeatureToolConnected(false);
        }
      }
      if (
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.feedbackTypes &&
        productParams.products[0].zendeskSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        )
      ) {
        if (
          productParams.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEEDBACK
          ].type == "SELF"
        ) {
          const temp = { ...productParams };
          temp.products[0].zendeskSettings.configs[
            FEEDBACK_TYPE_FEEDBACK
          ].type = "ZENDESK";
          setProductParams(temp);
        }
        if (
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs.FEEDBACK &&
          productParams.products[0].zendeskSettings.configs.FEEDBACK
            .isToolConnected
        ) {
          setIsFeedbackToolConnected(true);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeedbackToolConnected: true,
              },
            },
            "Tool Connected"
          );
        } else if (
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs.FEEDBACK
        ) {
          setIsFeedbackToolConnected(false);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeedbackToolConnected: false,
              },
            },
            "Tool not Connected"
          );
        }
      }
    } else if (productParams && productParams.products[0]) {
      const temp = { ...productParams };
      temp.products[0]["zendeskSettings"] = defaultZendeskSettings;
      setProductParams(temp);
    }
  }, [productParams]);

  const removeHandleConnection = (type: string) => {
    if (type === FEEDBACK_TYPE_BUGS) {
      setIsBugToolConnected(false);
      if (
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.configs &&
        productParams.products[0].zendeskSettings.configs[FEEDBACK_TYPE_BUGS] &&
        productParams.products[0].zendeskSettings.configs[FEEDBACK_TYPE_BUGS]
          .isToolConnected
      ) {
        productParams.products[0].zendeskSettings.configs[
          FEEDBACK_TYPE_BUGS
        ].isToolConnected = false;
      }
    } else if (type === FEEDBACK_TYPE_FEEDBACK) {
      setIsFeedbackToolConnected(false);
      if (
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.configs &&
        productParams.products[0].zendeskSettings.configs.FEEDBACK &&
        productParams.products[0].zendeskSettings.configs.FEEDBACK
          .isToolConnected
      ) {
        productParams.products[0].zendeskSettings.configs.FEEDBACK.isToolConnected =
          false;
      }
    } else {
      setIsFeatureToolConnected(false);
      if (
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.configs &&
        productParams.products[0].zendeskSettings.configs[
          FEEDBACK_TYPE_FEATURE_REQ
        ] &&
        productParams.products[0].zendeskSettings.configs[
          FEEDBACK_TYPE_FEATURE_REQ
        ].isToolConnected
      ) {
        productParams.products[0].zendeskSettings.configs[
          FEEDBACK_TYPE_FEATURE_REQ
        ].isToolConnected = false;
      }
    }
  };

  const clearErrMsg = (errMsg: any, type: string) => {
    if (
      errMsg &&
      errMsg[type] &&
      errMsg[type].extProjectTypeErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].url
    ) {
      const msg = { ...errMsg };
      msg[type].extProjectTypeErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg &&
      errMsg[type] &&
      errMsg[type].extIssueTypeErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].auth &&
      productParams.products[0].zendeskSettings.configs[type].auth.authUser
    ) {
      const msg = { ...errMsg };
      msg[type].extIssueTypeErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg &&
      errMsg[type] &&
      errMsg[type].extDefaultSevErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].auth &&
      productParams.products[0].zendeskSettings.configs[type].auth.authKey
    ) {
      const msg = { ...errMsg };
      msg[type].extDefaultSevErr = null;
      setErrMsg(msg);
    }
  };

  const handleToolConnect = (type: string) => {
    if (
      productParams &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].url
    ) {
      if (
        productParams &&
        productParams.products[0] &&
        productParams.products[0].zendeskSettings &&
        productParams.products[0].zendeskSettings.configs &&
        productParams.products[0].zendeskSettings.configs[type] &&
        productParams.products[0].zendeskSettings.configs[type] &&
        productParams.products[0].zendeskSettings.configs[type].auth &&
        productParams.products[0].zendeskSettings.configs[type].auth.authUser
      ) {
        if (
          productParams &&
          productParams.products[0] &&
          productParams.products[0].zendeskSettings &&
          productParams.products[0].zendeskSettings.configs &&
          productParams.products[0].zendeskSettings.configs[type] &&
          productParams.products[0].zendeskSettings.configs[type].type &&
          productParams.products[0].zendeskSettings.configs[type].auth &&
          productParams.products[0].zendeskSettings.configs[type].auth.authKey
        ) {
          if (type) {
            fetchZendeskTags(type);
          }
        } else {
          props.snackbarShowMessage(
            "You must provide tracking system auth key",
            "error",
            3000
          );
          const updatedValue = {
            [type]: {
              trackingKeyErr: "You must provide tracking system auth Key",
            },
          };
          setFieldErrMsg(() => ({
            ...{},
            ...updatedValue,
          }));
          return false;
        }
      } else {
        props.snackbarShowMessage(
          "You must provide tracking system auth User Email",
          "error",
          3000
        );
        const updatedValue = {
          [type]: {
            trackingUserErr: "You must provide tracking system auth User Email",
          },
        };
        setFieldErrMsg(() => ({
          ...{},
          ...updatedValue,
        }));
        return false;
      }
    } else {
      appLogger.error(
        { errObj: { method: "handleToolConnect" } },
        "url missing"
      );
      props.snackbarShowMessage(
        "You must provide tracking system URL",
        "error",
        3000
      );
      const updatedValue = {
        [type]: {
          trackingUrlErr: "You must provide tracking system URL",
        },
      };
      setFieldErrMsg(() => ({
        ...{},
        ...updatedValue,
      }));
      return false;
    }
  };

  useEffect(() => {
    if (isBugToolConnected) {
      handleToolConnect(FEEDBACK_TYPE_BUGS);
    }
  }, [isBugToolConnected]);

  useEffect(() => {
    if (isFeatureToolConnected) {
      handleToolConnect(FEEDBACK_TYPE_FEATURE_REQ);
    }
  }, [isFeatureToolConnected]);

  useEffect(() => {
    if (isFeedbackToolConnected) {
      handleToolConnect(FEEDBACK_TYPE_FEEDBACK);
    }
  }, [isFeedbackToolConnected]);

  const handleToolConnectStatus = (type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].zendeskSettings &&
        temp.products[0].zendeskSettings.configs
      ) {
        if (
          temp &&
          temp.products[0] &&
          temp.products[0].zendeskSettings &&
          temp.products[0].zendeskSettings.configs &&
          temp.products[0].zendeskSettings.configs[type]
        ) {
          temp.products[0].zendeskSettings.configs[type].isToolConnected = true;
          if (type == FEEDBACK_TYPE_FEEDBACK) {
            setIsFeedbackToolConnected(true);
          } else if (type == FEEDBACK_TYPE_BUGS) {
            setIsBugToolConnected(true);
          } else if (type == FEEDBACK_TYPE_FEATURE_REQ) {
            setIsFeatureToolConnected(true);
          }
          setProductParams(temp);
        }
      }
    }
  };

  const fetchZendeskTags = (type: string) => {
    setIsLoading(type);
    const authData = {
      ...productParams.products[0].zendeskSettings.configs[type].auth,
    };
    authData.authUser = authData.authUser.toLowerCase();
    Http.post({
      url: `/api/v2/extTrackingSystem/`,
      state: userInfo,
      body: {
        tool: "ZENDESK",
        field: "tags",
        url: productParams.products[0].zendeskSettings.configs[type].url,
        config: authData,
      },
    })
      .then((response: any) => {
        setIsLoading("");
        const tags = [...response.result];
        if (tags && tags.length > 0) {
          appLogger.info({
            infoObj: {
              method: "fetchZendeskTags",
              component: "add-product",
              fileName: "trackingSysSettings.tsx",
              tagListResponse: response.result,
            },
          });
          const zenTags = { ...zendeskTagList };
          if (
            productParams &&
            productParams.products[0] &&
            productParams.products[0].zendeskSettings &&
            productParams.products[0].zendeskSettings.configs &&
            productParams.products[0].zendeskSettings.configs[type] &&
            productParams.products[0].zendeskSettings.configs[type].tags &&
            productParams.products[0].zendeskSettings.configs[type].tags
              .length > 0
          ) {
            zenTags[type] = [
              ...tags,
              ...productParams.products[0].zendeskSettings.configs[type].tags,
            ];
            zenTags[type] = [...new Set(zenTags[type])];
            setZendeskTagList((prev: any) => {
              return { ...prev, ...zenTags };
            });
          } else {
            zenTags[type] = tags;
            setZendeskTagList((prev: any) => {
              return { ...prev, ...zenTags };
            });
          }
        } else {
          const zenTags = { ...zendeskTagList };
          if (
            productParams &&
            productParams.products[0] &&
            productParams.products[0].zendeskSettings &&
            productParams.products[0].zendeskSettings.configs &&
            productParams.products[0].zendeskSettings.configs[type] &&
            productParams.products[0].zendeskSettings.configs[type].tags &&
            productParams.products[0].zendeskSettings.configs[type].tags
              .length > 0
          ) {
            zenTags[type] = [
              ...[],
              ...productParams.products[0].zendeskSettings.configs[type].tags,
            ];
            zenTags[type] = [...new Set(zenTags[type])];
            setZendeskTagList(zendeskTagList);
          } else {
            zenTags[type] = [];
            setZendeskTagList((prev: any) => {
              return { ...zenTags };
            });
          }
        }

        handleToolConnectStatus(type);
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "fetchZendeskTags",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            err: error,
          },
        });
        const zenTags = { ...zendeskTagList };
        zenTags[type] = [];
        setZendeskTagList((prev: any) => {
          return { ...zenTags, ...prev };
        });
        setIsLoading("");
        props.snackbarShowMessage(
          "Not able to connect to Zendesk",
          "error",
          3000
        );
      });
  };

  const clearFieldErrMsg = (fieldErrMsg: any, type: string) => {
    if (
      fieldErrMsg &&
      fieldErrMsg[type] &&
      fieldErrMsg[type].trackingUrlErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].url
    ) {
      const msg = { ...fieldErrMsg };
      msg[type].trackingUrlErr = null;
      setFieldErrMsg(msg);
    }
    if (
      fieldErrMsg &&
      fieldErrMsg[type] &&
      fieldErrMsg[type].trackingUserErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].auth &&
      productParams.products[0].zendeskSettings.configs[type].auth.authUser
    ) {
      const msg = { ...fieldErrMsg };
      msg[type].trackingUserErr = null;
      setFieldErrMsg(msg);
    }
    if (
      fieldErrMsg &&
      fieldErrMsg[type] &&
      fieldErrMsg[type].trackingKeyErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].zendeskSettings &&
      productParams.products[0].zendeskSettings.configs &&
      productParams.products[0].zendeskSettings.configs[type] &&
      productParams.products[0].zendeskSettings.configs[type].auth &&
      productParams.products[0].zendeskSettings.configs[type].auth.authKey
    ) {
      const msg = { ...fieldErrMsg };
      msg[type].trackingKeyErr = null;
      setFieldErrMsg(msg);
    }
  };

  const handleAuthUserDetails = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].zendeskSettings &&
        temp.products[0].zendeskSettings.configs
      ) {
        const newData = temp.products[0].zendeskSettings.configs;
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].zendeskSettings &&
          temp.products[0].zendeskSettings.configs &&
          temp.products[0].zendeskSettings.configs[type]
        ) {
          if (temp.products[0].zendeskSettings.configs[type].auth) {
            temp.products[0].zendeskSettings.configs[type].auth.authUser =
              event.target.value;
          } else {
            temp.products[0].zendeskSettings.configs[type].auth = {};
            temp.products[0].zendeskSettings.configs[type].auth.authUser =
              event.target.value;
          }
        } else {
          newData[type].auth = {};
          newData[type].auth.authUser = event.target.value;
          temp.products[0].zendeskSettings.configs = newData;
        }
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
      }
    }
  };

  const handleAuthKeyDetails = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].zendeskSettings &&
        temp.products[0].zendeskSettings.configs
      ) {
        const newData = temp.products[0].zendeskSettings.configs;
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].zendeskSettings &&
          temp.products[0].zendeskSettings.configs &&
          temp.products[0].zendeskSettings.configs[type]
        ) {
          if (temp.products[0].zendeskSettings.configs[type].auth) {
            temp.products[0].zendeskSettings.configs[type].auth.authKey =
              event.target.value;
          } else {
            temp.products[0].zendeskSettings.configs[type].auth = {};
            temp.products[0].zendeskSettings.configs[type].auth.authKey =
              event.target.value;
          }
        } else {
          newData[type].auth = {};
          newData[type].auth.authUser = event.target.value;
          temp.products[0].zendeskSettings.configs = newData;
        }
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
      }
    }
  };

  const addDynamicTags = (type: string, field: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].zendeskSettings &&
        temp.products[0].zendeskSettings.configs
      ) {
        const newMessages = temp.products[0].zendeskSettings.configs;
        if (newMessages[type]) {
          if (Array.isArray(newMessages[type][field]) && dynamicTag != "") {
            newMessages[type][field].push(dynamicTag);
          } else if (dynamicTag != "") {
            newMessages[type][field] = [dynamicTag];
          }
        }
        temp.products[0].zendeskSettings.configs = newMessages;
        clearErrMsg(errMsg, type);
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
        const zenTags = { ...zendeskTagList };
        if (dynamicTag != "") {
          zenTags[type] = [...zenTags[type], ...[dynamicTag]];
        }
        setZendeskTagList(zenTags);
        setDynamicTag("");
      }
    }
  };
  const handleFieldChange = (event: any, type: string, field: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].zendeskSettings &&
        temp.products[0].zendeskSettings.configs
      ) {
        const newMessages = temp.products[0].zendeskSettings.configs;
        if (newMessages[type]) {
          newMessages[type][field] = event.target.value;
        }
        temp.products[0].zendeskSettings.configs = newMessages;
        clearErrMsg(errMsg, type);
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
      }
    }
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  return (
    <Box className="accordion-wrap">
      <ZendeskSettingsHeader product={productParams?.products?.[0]} />
      {productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.length >
          0 &&
        ((productParams.products[0].feedbackAgentSettings.feedbackTypes &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
            FEEDBACK_TYPE_BUGS
          )) ||
          (productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              FEEDBACK_TYPE_FEATURE_REQ
            )) ||
          (productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              FEEDBACK_TYPE_FEEDBACK
            ))) && (
          <>
            {userEnabledFeatures?.enableFeedback &&
            enableFeedback &&
            productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              "FEEDBACK"
            ) ? (
              <Grid sx={{ mt: 2, mb: 2 }} item xs={12}>
                <Box
                  className={
                    isLoading &&
                    isLoading.length > 0 &&
                    isLoading === FEEDBACK_TYPE_FEEDBACK &&
                    !isFeedbackToolConnected
                      ? "feedback-track-wrap loader"
                      : "feedback-track-wrap"
                  }
                >
                  <Typography className="title">Feedback</Typography>
                  <>
                    {enableZendesk ? (
                      <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              The URl for your tracking/incident management
                              system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEEDBACK &&
                              fieldErrMsg.FEEDBACK.trackingUrlErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEEDBACK.trackingUrlErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].zendeskSettings &&
                                productParams.products[0].zendeskSettings
                                  .configs &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEEDBACK &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEEDBACK.url
                                  ? productParams.products[0].zendeskSettings
                                      .configs.FEEDBACK.url
                                  : ""
                              }
                              disabled={isFeedbackToolConnected}
                              onChange={(event) =>
                                handleFieldChange(
                                  event,
                                  FEEDBACK_TYPE_FEEDBACK,
                                  "url"
                                )
                              }
                              id="urlTracking-select"
                              label="urlTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Provide auth user email for your tracking/incident
                              management system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEEDBACK &&
                              fieldErrMsg.FEEDBACK.trackingUserErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEEDBACK.trackingUserErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].zendeskSettings &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEEDBACK.auth &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEEDBACK.auth["authUser"]
                                  ? productParams.products[0].zendeskSettings
                                      .configs.FEEDBACK.auth["authUser"]
                                  : ""
                              }
                              onChange={(event) =>
                                handleAuthUserDetails(
                                  event,
                                  FEEDBACK_TYPE_FEEDBACK
                                )
                              }
                              disabled={isFeedbackToolConnected}
                              id="emailTracking-select"
                              label="emailTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <HideOrShowText
                            placeHolder={
                              "Provide auth key for your tracking/incident management system"
                            }
                            value={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].zendeskSettings &&
                              productParams.products[0].zendeskSettings.configs[
                                FEEDBACK_TYPE_FEEDBACK
                              ].auth &&
                              productParams.products[0].zendeskSettings.configs[
                                FEEDBACK_TYPE_FEEDBACK
                              ].auth["authKey"]
                                ? productParams.products[0].zendeskSettings
                                    .configs[FEEDBACK_TYPE_FEEDBACK].auth[
                                    "authKey"
                                  ]
                                : ""
                            }
                            fieldKey={"zFeedbackAuthKey"}
                            onChange={(e) =>
                              handleAuthKeyDetails(e, FEEDBACK_TYPE_FEEDBACK)
                            }
                            disabled={isFeedbackToolConnected}
                            isMandatory={true}
                          />
                        </Grid>
                        {isFeedbackToolConnected ? (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={() =>
                                removeHandleConnection(FEEDBACK_TYPE_FEEDBACK)
                              }
                              // className="create-pro-btn"
                            >
                              Edit Connection Details
                            </Button>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={(event) =>
                                handleToolConnect(FEEDBACK_TYPE_FEEDBACK)
                              }
                              // className="create-pro-btn"
                            >
                              Connect
                            </Button>
                          </Grid>
                        )}
                        {isFeedbackToolConnected ? (
                          <>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>
                                  Provide subject for your zendesk ticket
                                </InputLabel>
                                <OutlinedInput
                                  type="text"
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0].zendeskSettings &&
                                    productParams.products[0].zendeskSettings
                                      .configs.FEEDBACK.subject
                                      ? productParams.products[0]
                                          .zendeskSettings.configs.FEEDBACK
                                          .subject
                                      : ""
                                  }
                                  onChange={(event) =>
                                    handleFieldChange(
                                      event,
                                      FEEDBACK_TYPE_FEEDBACK,
                                      "subject"
                                    )
                                  }
                                  id="subject-select"
                                  label="subject"
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>Choose your tags:</InputLabel>
                                <Select
                                  labelId="tracking-pro-select"
                                  id="tracking-pro-select"
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0].zendeskSettings &&
                                    productParams.products[0].zendeskSettings
                                      .configs &&
                                    productParams.products[0].zendeskSettings
                                      .configs.FEEDBACK &&
                                    productParams.products[0].zendeskSettings
                                      .configs.FEEDBACK.tags
                                      ? Array.isArray(
                                          productParams.products[0]
                                            .zendeskSettings.configs.FEEDBACK
                                            .tags
                                        )
                                        ? productParams.products[0]
                                            .zendeskSettings.configs.FEEDBACK
                                            .tags
                                        : [
                                            productParams.products[0]
                                              .zendeskSettings.configs.FEEDBACK
                                              .tags,
                                          ]
                                      : []
                                  }
                                  label="flow"
                                  onChange={(event) =>
                                    handleFieldChange(
                                      event,
                                      FEEDBACK_TYPE_FEEDBACK,
                                      "tags"
                                    )
                                  }
                                  multiple
                                  input={
                                    <OutlinedInput
                                      id="select-multiple-chip"
                                      label="Chip"
                                    />
                                  }
                                  renderValue={(selected: any) => (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 0.5,
                                      }}
                                    >
                                      {selected.map((value: any) => (
                                        <Chip key={value} label={value} />
                                      ))}
                                    </Box>
                                  )}
                                >
                                  {zendeskTagList &&
                                    zendeskTagList[FEEDBACK_TYPE_FEEDBACK] &&
                                    zendeskTagList[FEEDBACK_TYPE_FEEDBACK]
                                      .length > 0 &&
                                    zendeskTagList[FEEDBACK_TYPE_FEEDBACK].map(
                                      (menu: any, index: number) => {
                                        return (
                                          <MenuItem key={menu} value={menu}>
                                            {menu}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Add new tags to your ticket
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={dynamicTag}
                                    onChange={(event) =>
                                      setDynamicTag(
                                        event.target.value
                                          .toLocaleLowerCase()
                                          .replace(/\s/g, "")
                                      )
                                    }
                                    id="subject-select"
                                    label="subject"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                <Button
                                  size="small"
                                  onClick={(event) =>
                                    addDynamicTags(
                                      FEEDBACK_TYPE_FEEDBACK,
                                      "tags"
                                    )
                                  }
                                >
                                  Add tags
                                </Button>
                              </Grid>
                            </Grid>
                            {isFeedbackToolConnected &&
                              zendeskTicketTypeList &&
                              zendeskTicketTypeList.length > 0 && (
                                <>
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your ticket type:
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-pro-select"
                                        id="tracking-pro-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .zendeskSettings &&
                                          productParams.products[0]
                                            .zendeskSettings.configs &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.FEEDBACK &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.FEEDBACK
                                            .ticketType
                                            ? productParams.products[0]
                                                .zendeskSettings.configs
                                                .FEEDBACK.ticketType
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_FEEDBACK,
                                            "ticketType"
                                          )
                                        }
                                      >
                                        {zendeskTicketTypeList &&
                                          zendeskTicketTypeList.length > 0 &&
                                          zendeskTicketTypeList.map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </>
                              )}
                            {isFeedbackToolConnected &&
                              zendeskPriorityList &&
                              zendeskPriorityList?.length > 0 && (
                                <>
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your default priority, if user
                                        doesn't select any:
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-sev-select"
                                        id="tracking-sev-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .zendeskSettings &&
                                          productParams.products[0]
                                            .zendeskSettings.configs &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.FEEDBACK &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.FEEDBACK
                                            .defaultSeverity
                                            ? productParams.products[0]
                                                .zendeskSettings.configs
                                                .FEEDBACK.defaultSeverity
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_FEEDBACK,
                                            "defaultSeverity"
                                          )
                                        }
                                      >
                                        {zendeskPriorityList.length > 0 &&
                                          zendeskPriorityList.map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </>
                              )}
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
            {((userEnabledFeatures?.enableBugReport && enableBugReport) ||
              (userEnabledFeatures?.enableChatbot && enableChatbot)) &&
            productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              FEEDBACK_TYPE_BUGS
            ) ? (
              <Grid sx={{ mt: 2 }} item xs={12}>
                <Box
                  className={
                    isLoading &&
                    isLoading.length > 0 &&
                    isLoading === FEEDBACK_TYPE_BUGS &&
                    !isBugToolConnected
                      ? "bug-track-wrap loader"
                      : "bug-track-wrap"
                  }
                >
                  <Typography className="title">Tickets</Typography>
                  <>
                    {enableZendesk ? (
                      <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              The URl for your tracking/incident management
                              system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.BUGS &&
                              fieldErrMsg.BUGS.trackingUrlErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.BUGS.trackingUrlErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].zendeskSettings &&
                                productParams.products[0].zendeskSettings
                                  .configs &&
                                productParams.products[0].zendeskSettings
                                  .configs.BUGS &&
                                productParams.products[0].zendeskSettings
                                  .configs.BUGS.url
                                  ? productParams.products[0].zendeskSettings
                                      .configs.BUGS.url
                                  : ""
                              }
                              disabled={isBugToolConnected}
                              onChange={(event) =>
                                handleFieldChange(
                                  event,
                                  FEEDBACK_TYPE_BUGS,
                                  "url"
                                )
                              }
                              id="urlTracking-select"
                              label="urlTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Provide auth user email for your tracking/incident
                              management system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.BUGS &&
                              fieldErrMsg.BUGS.trackingUserErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.BUGS.trackingUserErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].zendeskSettings &&
                                productParams.products[0].zendeskSettings
                                  .configs.BUGS.auth &&
                                productParams.products[0].zendeskSettings
                                  .configs.BUGS.auth["authUser"]
                                  ? productParams.products[0].zendeskSettings
                                      .configs.BUGS.auth["authUser"]
                                  : ""
                              }
                              onChange={(event) =>
                                handleAuthUserDetails(event, FEEDBACK_TYPE_BUGS)
                              }
                              disabled={isBugToolConnected}
                              id="emailTracking-select"
                              label="emailTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <HideOrShowText
                            placeHolder={
                              "Provide auth key for your tracking/incident management system"
                            }
                            value={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].zendeskSettings &&
                              productParams.products[0].zendeskSettings.configs[
                                FEEDBACK_TYPE_BUGS
                              ].auth &&
                              productParams.products[0].zendeskSettings.configs[
                                FEEDBACK_TYPE_BUGS
                              ].auth["authKey"]
                                ? productParams.products[0].zendeskSettings
                                    .configs[FEEDBACK_TYPE_BUGS].auth["authKey"]
                                : ""
                            }
                            fieldKey={"zbugAuthKey"}
                            onChange={(e) =>
                              handleAuthKeyDetails(e, FEEDBACK_TYPE_BUGS)
                            }
                            disabled={isBugToolConnected}
                            isMandatory={true}
                          />
                        </Grid>
                        {isBugToolConnected ? (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={() =>
                                removeHandleConnection(FEEDBACK_TYPE_BUGS)
                              }
                              // className="create-pro-btn"
                            >
                              Edit Connection Details
                            </Button>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={(event) =>
                                handleToolConnect(FEEDBACK_TYPE_BUGS)
                              }
                              // className="create-pro-btn"
                            >
                              Connect
                            </Button>
                          </Grid>
                        )}
                        {isBugToolConnected ? (
                          <>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>
                                  Provide subject for your zendesk ticket
                                </InputLabel>
                                <OutlinedInput
                                  type="text"
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0].zendeskSettings &&
                                    productParams.products[0].zendeskSettings
                                      .configs.BUGS.subject
                                      ? productParams.products[0]
                                          .zendeskSettings.configs.BUGS.subject
                                      : ""
                                  }
                                  onChange={(event) =>
                                    handleFieldChange(
                                      event,
                                      FEEDBACK_TYPE_BUGS,
                                      "subject"
                                    )
                                  }
                                  id="subject-select"
                                  label="subject"
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>Choose your tags:</InputLabel>
                                <Select
                                  labelId="tracking-pro-select"
                                  id="tracking-pro-select"
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0].zendeskSettings &&
                                    productParams.products[0].zendeskSettings
                                      .configs &&
                                    productParams.products[0].zendeskSettings
                                      .configs.BUGS &&
                                    productParams.products[0].zendeskSettings
                                      .configs.BUGS.tags
                                      ? Array.isArray(
                                          productParams.products[0]
                                            .zendeskSettings.configs.BUGS.tags
                                        )
                                        ? productParams.products[0]
                                            .zendeskSettings.configs.BUGS.tags
                                        : [
                                            productParams.products[0]
                                              .zendeskSettings.configs.BUGS
                                              .tags,
                                          ]
                                      : []
                                  }
                                  label="flow"
                                  onChange={(event) =>
                                    handleFieldChange(
                                      event,
                                      FEEDBACK_TYPE_BUGS,
                                      "tags"
                                    )
                                  }
                                  multiple
                                  input={
                                    <OutlinedInput
                                      id="select-multiple-chip"
                                      label="Chip"
                                    />
                                  }
                                  renderValue={(selected: any) => (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 0.5,
                                      }}
                                    >
                                      {selected.map((value: any) => (
                                        <Chip key={value} label={value} />
                                      ))}
                                    </Box>
                                  )}
                                >
                                  {zendeskTagList &&
                                    zendeskTagList[FEEDBACK_TYPE_BUGS] &&
                                    zendeskTagList[FEEDBACK_TYPE_BUGS].length >
                                      0 &&
                                    zendeskTagList[FEEDBACK_TYPE_BUGS].map(
                                      (menu: any, index: number) => {
                                        return (
                                          <MenuItem key={menu} value={menu}>
                                            {menu}
                                          </MenuItem>
                                        );
                                      }
                                    )}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Add new tags to your ticket
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={dynamicTag}
                                    onChange={(event) =>
                                      setDynamicTag(
                                        event.target.value
                                          .toLocaleLowerCase()
                                          .replace(/\s/g, "")
                                      )
                                    }
                                    id="subject-select"
                                    label="subject"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                <Button
                                  size="small"
                                  onClick={(event) =>
                                    addDynamicTags(FEEDBACK_TYPE_BUGS, "tags")
                                  }
                                >
                                  Add tags
                                </Button>
                              </Grid>
                            </Grid>
                            {isBugToolConnected &&
                              zendeskTicketTypeList &&
                              zendeskTicketTypeList.length > 0 && (
                                <>
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your ticket type:
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-pro-select"
                                        id="tracking-pro-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .zendeskSettings &&
                                          productParams.products[0]
                                            .zendeskSettings.configs &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.BUGS &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.BUGS
                                            .ticketType
                                            ? productParams.products[0]
                                                .zendeskSettings.configs.BUGS
                                                .ticketType
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_BUGS,
                                            "ticketType"
                                          )
                                        }
                                      >
                                        {zendeskTicketTypeList &&
                                          zendeskTicketTypeList.length > 0 &&
                                          zendeskTicketTypeList.map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </>
                              )}
                            {isBugToolConnected &&
                              zendeskPriorityList &&
                              zendeskPriorityList.length > 0 && (
                                <>
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your default priority, if user
                                        doesn't select any:
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-sev-select"
                                        id="tracking-sev-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .zendeskSettings &&
                                          productParams.products[0]
                                            .zendeskSettings.configs &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.BUGS &&
                                          productParams.products[0]
                                            .zendeskSettings.configs.BUGS
                                            .defaultSeverity
                                            ? productParams.products[0]
                                                .zendeskSettings.configs.BUGS
                                                .defaultSeverity
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_BUGS,
                                            "defaultSeverity"
                                          )
                                        }
                                      >
                                        {zendeskPriorityList.length > 0 &&
                                          zendeskPriorityList.map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </>
                              )}
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
            {userEnabledFeatures?.enableFeatureRequest &&
            enableFeatureRequest &&
            productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              "FEATURE_REQUEST"
            ) ? (
              <Grid sx={{ mt: 2 }} item xs={12}>
                <Box
                  className={
                    isLoading &&
                    isLoading.length > 0 &&
                    isLoading === FEEDBACK_TYPE_FEATURE_REQ &&
                    !isFeatureToolConnected
                      ? "feature-track-wrap loader"
                      : "feature-track-wrap"
                  }
                >
                  <Typography className="title">feature request</Typography>
                  <>
                    {enableZendesk ? (
                      <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              The URl for your tracking/incident management
                              system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEATURE_REQUEST &&
                              fieldErrMsg.FEATURE_REQUEST.trackingUrlErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEATURE_REQUEST.trackingUrlErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].zendeskSettings &&
                                productParams.products[0].zendeskSettings
                                  .configs &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEATURE_REQUEST &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEATURE_REQUEST.url
                                  ? productParams.products[0].zendeskSettings
                                      .configs.FEATURE_REQUEST.url
                                  : ""
                              }
                              disabled={isFeatureToolConnected}
                              onChange={(event) =>
                                handleFieldChange(
                                  event,
                                  FEEDBACK_TYPE_FEATURE_REQ,
                                  "url"
                                )
                              }
                              id="urlTracking-select"
                              label="urlTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Provide auth user email for your tracking/incident
                              management system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEATURE_REQUEST &&
                              fieldErrMsg.FEATURE_REQUEST.trackingUserErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEATURE_REQUEST.trackingUserErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].zendeskSettings &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEATURE_REQUEST.auth &&
                                productParams.products[0].zendeskSettings
                                  .configs.FEATURE_REQUEST.auth["authUser"]
                                  ? productParams.products[0].zendeskSettings
                                      .configs.FEATURE_REQUEST.auth["authUser"]
                                  : ""
                              }
                              onChange={(event) =>
                                handleAuthUserDetails(
                                  event,
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              disabled={isFeatureToolConnected}
                              id="emailTracking-select"
                              label="emailTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <HideOrShowText
                            placeHolder={
                              "Provide auth key for your tracking/incident management system"
                            }
                            value={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].zendeskSettings &&
                              productParams.products[0].zendeskSettings.configs[
                                FEEDBACK_TYPE_FEATURE_REQ
                              ].auth &&
                              productParams.products[0].zendeskSettings.configs[
                                FEEDBACK_TYPE_FEATURE_REQ
                              ].auth["authKey"]
                                ? productParams.products[0].zendeskSettings
                                    .configs[FEEDBACK_TYPE_FEATURE_REQ].auth[
                                    "authKey"
                                  ]
                                : ""
                            }
                            fieldKey={"zFeatureAuthkey"}
                            onChange={(e) =>
                              handleAuthKeyDetails(e, FEEDBACK_TYPE_FEATURE_REQ)
                            }
                            disabled={isFeatureToolConnected}
                            isMandatory={true}
                          />
                        </Grid>
                        {isFeatureToolConnected ? (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={() =>
                                removeHandleConnection(
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              // className="create-pro-btn"
                            >
                              Edit Connection Details
                            </Button>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={(event) =>
                                handleToolConnect(FEEDBACK_TYPE_FEATURE_REQ)
                              }
                              // className="create-pro-btn"
                            >
                              Connect
                            </Button>
                          </Grid>
                        )}
                        {isFeatureToolConnected ? (
                          <>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>
                                  Provide subject for your zendesk ticket
                                </InputLabel>
                                <OutlinedInput
                                  type="text"
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0].zendeskSettings &&
                                    productParams.products[0].zendeskSettings
                                      .configs.FEATURE_REQUEST.subject
                                      ? productParams.products[0]
                                          .zendeskSettings.configs
                                          .FEATURE_REQUEST.subject
                                      : ""
                                  }
                                  onChange={(event) =>
                                    handleFieldChange(
                                      event,
                                      FEEDBACK_TYPE_FEATURE_REQ,
                                      "subject"
                                    )
                                  }
                                  id="subject-select"
                                  label="subject"
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 2 }}>
                              <FormControl className="custom-select" fullWidth>
                                <InputLabel>Choose your tags:</InputLabel>
                                <Select
                                  labelId="tracking-pro-select"
                                  id="tracking-pro-select"
                                  value={
                                    productParams &&
                                    productParams.products &&
                                    productParams.products[0] &&
                                    productParams.products[0].zendeskSettings &&
                                    productParams.products[0].zendeskSettings
                                      .configs &&
                                    productParams.products[0].zendeskSettings
                                      .configs.FEATURE_REQUEST &&
                                    productParams.products[0].zendeskSettings
                                      .configs.FEATURE_REQUEST.tags
                                      ? Array.isArray(
                                          productParams.products[0]
                                            .zendeskSettings.configs
                                            .FEATURE_REQUEST.tags
                                        )
                                        ? productParams.products[0]
                                            .zendeskSettings.configs
                                            .FEATURE_REQUEST.tags
                                        : [
                                            productParams.products[0]
                                              .zendeskSettings.configs
                                              .FEATURE_REQUEST.tags,
                                          ]
                                      : []
                                  }
                                  label="flow"
                                  onChange={(event) =>
                                    handleFieldChange(
                                      event,
                                      FEEDBACK_TYPE_FEATURE_REQ,
                                      "tags"
                                    )
                                  }
                                  multiple
                                  input={
                                    <OutlinedInput
                                      id="select-multiple-chip"
                                      label="Chip"
                                    />
                                  }
                                  renderValue={(selected: any) => (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 0.5,
                                      }}
                                    >
                                      {selected.map((value: any) => (
                                        <Chip key={value} label={value} />
                                      ))}
                                    </Box>
                                  )}
                                >
                                  {zendeskTagList &&
                                    zendeskTagList[FEEDBACK_TYPE_FEATURE_REQ] &&
                                    zendeskTagList[FEEDBACK_TYPE_FEATURE_REQ]
                                      .length > 0 &&
                                    zendeskTagList[
                                      FEEDBACK_TYPE_FEATURE_REQ
                                    ].map((menu: any, index: number) => {
                                      return (
                                        <MenuItem key={menu} value={menu}>
                                          {menu}
                                        </MenuItem>
                                      );
                                    })}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Add new tags to your ticket
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={dynamicTag}
                                    onChange={(event) =>
                                      setDynamicTag(
                                        event.target.value
                                          .toLocaleLowerCase()
                                          .replace(/\s/g, "")
                                      )
                                    }
                                    id="subject-select"
                                    label="subject"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                                <Button
                                  size="small"
                                  onClick={(event) =>
                                    addDynamicTags(
                                      FEEDBACK_TYPE_FEATURE_REQ,
                                      "tags"
                                    )
                                  }
                                >
                                  Add tags
                                </Button>
                              </Grid>
                            </Grid>
                            {isFeatureToolConnected &&
                              zendeskTicketTypeList &&
                              zendeskTicketTypeList.length > 0 && (
                                <>
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your ticket type:
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-pro-select"
                                        id="tracking-pro-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .zendeskSettings &&
                                          productParams.products[0]
                                            .zendeskSettings.configs &&
                                          productParams.products[0]
                                            .zendeskSettings.configs
                                            .FEATURE_REQUEST &&
                                          productParams.products[0]
                                            .zendeskSettings.configs
                                            .FEATURE_REQUEST.ticketType
                                            ? productParams.products[0]
                                                .zendeskSettings.configs
                                                .FEATURE_REQUEST.ticketType
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_FEATURE_REQ,
                                            "ticketType"
                                          )
                                        }
                                      >
                                        {zendeskTicketTypeList &&
                                          zendeskTicketTypeList.length > 0 &&
                                          zendeskTicketTypeList.map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </>
                              )}
                            {isFeatureToolConnected &&
                              zendeskPriorityList &&
                              zendeskPriorityList.length > 0 && (
                                <>
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your default priority, if user
                                        doesn't select any:
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-sev-select"
                                        id="tracking-sev-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .zendeskSettings &&
                                          productParams.products[0]
                                            .zendeskSettings.configs &&
                                          productParams.products[0]
                                            .zendeskSettings.configs
                                            .FEATURE_REQUEST &&
                                          productParams.products[0]
                                            .zendeskSettings.configs
                                            .FEATURE_REQUEST.defaultSeverity
                                            ? productParams.products[0]
                                                .zendeskSettings.configs
                                                .FEATURE_REQUEST.defaultSeverity
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_FEATURE_REQ,
                                            "defaultSeverity"
                                          )
                                        }
                                      >
                                        {zendeskPriorityList.length > 0 &&
                                          zendeskPriorityList.map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </>
                              )}
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
          </>
        )}
    </Box>
  );
};

export default withSnackbar(TrackingSystemSettings);
